export * from './embed-apps';
export * from './meeting';

export const commonSelector = (state) => state.commonReducer;
